<!--
     <ActionAllowedContents
       size='small'
       :unit="QUnit"
       @transition="action_transition(transition_obj)"
     />
-->

<template>
  <v-menu
    v-if="show_action"
    dense
    top
    offset-y
    content-class="qmkey-explorer-table-menu-contents"
    :disabled="disabled"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        :color="color"
        :small="size == 'small'"
        :large="size == 'large'"
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
        @click="click"
      >
        mdi-plus
      </v-icon>
    </template>

    <v-list dense class="overflow-y-auto">
      <v-list-item
        v-for="allowed in unit.allowed_content_types"
        :key="allowed.reference"
        @click.stop="action_transition(allowed)"
      >
        <v-list-item-content>
          <v-list-item-title
            v-text="allowed.readable_type"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>


<script>
 export default {
   name: "ActionAllowedContents",

   props: {
     size: {default: 'small'},
     unit: {required: true},
     color: {},
     disabled: Boolean
   },

   computed: {
    show_action() {
      return (this.unit.allowed_content_types || []).length > 0;
    },
  },

   methods: {
     action_transition(trans_obj) {
       this.$emit('clicked');
       this.$emit('transition', trans_obj);
     },

     click() {
      this.$emit('clicked');
     }
   },
 };
</script>
